import type { IFormConfig } from "../types";

const baseDefaults: Record<string, any> = {
  accountClass: "AccountReceivable",
  documentClass: "Invoice",
  poNumber: "",
  documentNumber: "",
  documentDate: null,
  dueDate: null,
  totalWithoutTax: null,
  totalDiscount: null,
  totalBeforeDiscount: null,
  totalTax: null,
  totalAfterTax: null,
  deliveryNote: "",
  comments: "",
  customerCompanyName: "",
  customerCompanyID: "",
  customerCompanyAddress: "",
  customerCompanyStreet: "",
  customerCompanyStreetNumber: "",
  customerCompanyLocality: "",
  customerCompanyRegion: "",
  customerCompanyZipCode: "",
  customerCountry: "",
  customerEmail: "",
  vendorCompanyName: "",
  vendorCompanyID: "",
  vendorCompanyAddress: "",
  vendorCompanyStreet: "",
  vendorCompanyStreetNumber: "",
  vendorCompanyLocality: "",
  vendorCompanyRegion: "",
  vendorCompanyZipCode: "",
  vendorCountry: "",
  vendorEmail: "",
  logoURL: "",
  items: [],
  taxes: [],
  uploadedDocument: "",
  pdfFile: "",
  currency: "",
  isExpenseCategory: false,
  referenceDocumentId: "",
  series: "",
  sequenceNumber: "",
  documentNumberSeriesId: "",
  RecurringDocument: {
    startDate: null,
    endDate: null,
    InvoiceDueInDays: null,
    RecurringFrequencyType: "",
  },
};

export const buildDefaults = (config: IFormConfig) => ({
  ...baseDefaults,
  ...config.defaults,
  documentClass: config.documentClass,
  accountClass: config.accountClass,
});
